import { JobListing } from '~/types/hlx/jobListing';
import { COMPENSATION_TYPE_OPTIONS, RVU_PERIOD_OPTIONS } from './constants';
import { CompensationFormValues } from './types';

export const transformApiToCompensationForm = (listing: JobListing): CompensationFormValues => {
  return {
    id: listing.detail?.id,
    jobListingId: listing.id,
    laborReqType: listing.detail?.laborReqType ?? null,
    compType:
      COMPENSATION_TYPE_OPTIONS.find((option) => option.value === listing.detail?.compType) ||
      COMPENSATION_TYPE_OPTIONS[0],
    pricePerHour: listing.detail?.pricePerHour ?? null,
    pricePerShift: listing.detail?.pricePerShift ?? null,
    pricePerRvu: listing.detail?.pricePerRvu ?? null,
    rvusPerPeriod: listing.detail?.rvusPerPeriod ?? null,
    rvuPeriod:
      RVU_PERIOD_OPTIONS.find((option) => option.value === listing.detail?.rvuPeriod) ?? null,
  };
};

export const transformCompensationFormToApi = (formValues: CompensationFormValues) => {
  const {
    compType,
    id,
    jobListingId,
    pricePerHour,
    pricePerShift,
    pricePerRvu,
    rvusPerPeriod,
    rvuPeriod,
  } = formValues;

  const basePayload = {
    id,
    jobListingId,
    compType: compType.value,
  };

  switch (compType.value) {
    case 'HOUR':
      return JSON.stringify({
        ...basePayload,
        pricePerHour,
      });
    case 'SHIFT':
      return JSON.stringify({
        ...basePayload,
        pricePerShift,
      });
    case 'RVU':
      return JSON.stringify({
        ...basePayload,
        pricePerRvu,
        ...(formValues.laborReqType === 'FTE' && {
          rvusPerPeriod,
          rvuPeriod: rvuPeriod?.value,
        }),
      });
    default:
      return JSON.stringify(basePayload);
  }
};
